import { cn } from "../lib/utils";

interface ButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  type?: "primary" | "secondary" | "disabled";
  className?: string;
  onClick?: () => void;
  secondary?: boolean;
  disabled?: boolean;
}

export const Button = ({ children, onClick, ...props }: ButtonProps) => {
  const { className, disabled, secondary } = props;
  let type = props.type || "primary";
  if (disabled) {
    type = "disabled";
  } else if (secondary) {
    type = "secondary";
  }
  return (
    <div
      {...props}
      className={cn(
        "flex flex-1 w-full justify-center max-h-[60px] items-center text-size-16 p-5 rounded-full gap-3 cursor-pointer ",
        "max-w-[calc(100vw-32px)]",
        type === "primary" && "bg-brand text-50",
        type === "secondary" && "text-brand border border-brand border-solid",
        type === "disabled" && "bg-100 text-200",
        className
      )}
      onClick={!disabled ? onClick : undefined}
    >
      {children}
    </div>
  );
};
